import React from 'react';
import SelectorPartidasPrograma, { fechaMasTemprana, especialidadDesdePartida, construirActMapPrograma, obtenerHojasProgramaDedup } from './SelectorPartidasPrograma';

/* ── Estilos inline para evitar conflictos con App.css (.modal-overlay y .modal-content
      están redefinidos ahí como side-panel, lo que rompe un modal centrado) ── */

const S = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0, 0, 0, 0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    pointerEvents: 'auto',
    backdropFilter: 'blur(2px)',
  },
  container: {
    width: '100%',
    maxWidth: '520px',
    maxHeight: '90vh',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '16px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    animation: 'mas-slide 0.25s ease',
  },
  header: {
    background: 'linear-gradient(135deg, #111827 0%, #2d4a6d 100%)',
    padding: '20px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
  },
  headerTitle: {
    margin: 0,
    fontSize: '17px',
    fontWeight: 700,
    color: '#ffffff',
    letterSpacing: '-0.2px',
  },
  closeBtn: {
    background: 'rgba(255,255,255,0.15)',
    border: 'none',
    color: '#ffffff',
    fontSize: '16px',
    lineHeight: 1,
    cursor: 'pointer',
    padding: '6px 8px',
    borderRadius: '6px',
    transition: 'background 0.15s',
    flexShrink: 0,
  },
  body: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    background: '#ffffff',
    overflowY: 'auto',
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#374151',
  },
  footer: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    padding: '16px 24px',
    borderTop: '1px solid #f3f4f6',
    background: '#f9fafb',
    flexShrink: 0,
  },
  cancelBtn: {
    padding: '9px 20px',
    background: '#ffffff',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    color: '#374151',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  submitBtn: {
    padding: '9px 24px',
    background: '#111827',
    border: 'none',
    borderRadius: '8px',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 700,
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
  },
  divider: {
    border: 'none',
    borderTop: '1px solid #f3f4f6',
    margin: '4px 0',
  },
};

function ModalAgregarSubcontrato({
  visible, onCerrar,
  sections,
  specialty, setSpecialty,
  taskText, setTaskText, dueDate, setDueDate,
  addTask,
  modoDesdePrograma, setModoDesdePrograma,
  actividadesSubcontrato, setActividadesSubcontrato,
  partidaPrograma, setPartidaPrograma,
  actMapPrograma, setActMapPrograma,
  obtenerActividadesKpi,
  nombresPlantillas, cargarNombresPlantillas,
  mostrarSugerenciasSubcontrato, setMostrarSugerenciasSubcontrato,
}) {
  if (!visible) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const ok = await addTask(e);
    if (ok) onCerrar();
  };

  return (
    <>
      <style>{`
        @keyframes mas-slide {
          from { opacity: 0; transform: translateY(-16px) scale(0.98); }
          to   { opacity: 1; transform: translateY(0)     scale(1);    }
        }
      `}</style>

      <div style={S.overlay} onClick={onCerrar}>
        <div style={S.container} onClick={e => e.stopPropagation()}>

          <div style={S.header}>
            <h2 style={S.headerTitle}>Agregar Nuevo Subcontrato</h2>
            <button type="button" style={S.closeBtn} onClick={onCerrar}>✕</button>
          </div>

          <form onSubmit={handleSubmit} style={{ display: 'contents' }}>
            <div style={S.body}>
              <div style={S.fieldGroup}>
                <label style={S.label}>Nombre del subcontrato</label>
                <div style={{ position: 'relative', width: '100%' }}>
                  <input
                    className="task-input"
                    type="text"
                    placeholder="Subcontrato"
                    value={taskText}
                    onChange={(e) => setTaskText(e.target.value)}
                    onFocus={() => { cargarNombresPlantillas(); setMostrarSugerenciasSubcontrato(true); }}
                    onBlur={() => setTimeout(() => setMostrarSugerenciasSubcontrato(false), 150)}
                    required
                    autoComplete="off"
                  />
                  {mostrarSugerenciasSubcontrato && (
                    <div style={{ position: 'absolute', zIndex: 250, background: 'white', border: '1px solid #e2e8f0', borderRadius: '8px', boxShadow: '0 4px 16px rgba(0,0,0,0.12)', width: '100%', maxHeight: 220, overflowY: 'auto', top: '100%', left: 0, marginTop: 2 }}>
                      {taskText.trim() && !nombresPlantillas.subcontratos.some(n => n.toLowerCase() === taskText.trim().toLowerCase()) && (
                        <div
                          onMouseDown={() => setMostrarSugerenciasSubcontrato(false)}
                          style={{ padding: '7px 12px', cursor: 'pointer', borderBottom: '1px solid #f1f5f9', fontSize: '0.82rem', color: '#111827', fontWeight: 600 }}
                          onMouseEnter={e => e.currentTarget.style.background = '#fff7ed'}
                          onMouseLeave={e => e.currentTarget.style.background = 'white'}
                        >
                          + Agregar nuevo nombre: "{taskText.trim()}"
                        </div>
                      )}
                      {nombresPlantillas.subcontratos
                        .filter(n => n.toLowerCase().includes(taskText.toLowerCase()))
                        .map(n => (
                          <div
                            key={n}
                            onMouseDown={() => setTaskText(n)}
                            style={{ padding: '7px 12px', cursor: 'pointer', borderBottom: '1px solid #f1f5f9', fontSize: '0.82rem', color: '#1e293b' }}
                            onMouseEnter={e => e.currentTarget.style.background = '#fff7ed'}
                            onMouseLeave={e => e.currentTarget.style.background = 'white'}
                          >
                            {n}
                          </div>
                        ))}
                      {!taskText.trim() && nombresPlantillas.subcontratos.length === 0 && (
                        <div style={{ padding: '12px', color: '#9ca3af', fontSize: '0.82rem', textAlign: 'center' }}>Sin resultados</div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <hr style={S.divider} />

              <div style={S.fieldGroup}>
                <label style={S.label}>Partida y fecha</label>
                <div style={{ display: 'flex', gap: '6px', margin: '4px 0' }}>
                  <button type="button"
                    onClick={() => { setModoDesdePrograma(false); setPartidaPrograma([]); setSpecialty(''); setDueDate(''); }}
                    style={{ padding: '5px 12px', borderRadius: '6px', fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer', border: '1.5px solid', borderColor: !modoDesdePrograma ? '#111827' : '#e2e8f0', background: !modoDesdePrograma ? '#111827' : '#f8fafc', color: !modoDesdePrograma ? '#fff' : '#64748b' }}
                  >Manual</button>
                  <button type="button"
                    onClick={() => {
                      setModoDesdePrograma(true);
                      if (actividadesSubcontrato.length === 0 && obtenerActividadesKpi) {
                        obtenerActividadesKpi().then(acts => {
                          setActividadesSubcontrato(obtenerHojasProgramaDedup(acts));
                          if (setActMapPrograma) setActMapPrograma(construirActMapPrograma(acts));
                        });
                      }
                    }}
                    style={{ padding: '5px 12px', borderRadius: '6px', fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer', border: '1.5px solid', borderColor: modoDesdePrograma ? '#111827' : '#e2e8f0', background: modoDesdePrograma ? '#111827' : '#f8fafc', color: modoDesdePrograma ? '#fff' : '#64748b' }}
                  >Desde Programa</button>
                </div>

                {modoDesdePrograma ? (
                  <div>
                    <SelectorPartidasPrograma
                      actividadesDisponibles={actividadesSubcontrato}
                      seleccionadas={partidaPrograma || []}
                      onCambiar={(nuevoArray) => {
                        setPartidaPrograma(nuevoArray);
                        setDueDate(fechaMasTemprana(nuevoArray));
                        setSpecialty(especialidadDesdePartida(nuevoArray, actMapPrograma));
                      }}
                    />
                    {dueDate && (
                      <div style={{ fontSize: '0.72rem', color: '#6b7280', marginTop: 3 }}>
                        Fecha inicio (la más temprana): <strong>{dueDate}</strong>
                      </div>
                    )}
                    {specialty && (
                      <div style={{ marginTop: 6 }}>
                        <label style={{ ...S.label, display: 'block', marginBottom: 4 }}>Sección (desde Programa)</label>
                        <input
                          className="task-input"
                          type="text"
                          value={specialty}
                          disabled
                          readOnly
                          style={{ background: '#f3f4f6', color: '#374151', cursor: 'not-allowed' }}
                        />
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    <select
                      className="made-by-select"
                      value={specialty}
                      onChange={(e) => setSpecialty(e.target.value)}
                      required
                      style={{ marginBottom: '8px' }}
                    >
                      <option value="">-- Seleccionar Sección --</option>
                      {[...sections].sort((a, b) => a.name.localeCompare(b.name)).map((section) => (
                        <option key={section.id} value={section.name}>
                          {section.name}
                        </option>
                      ))}
                      <option value="__nueva__">+ Nueva Sección...</option>
                    </select>

                    {specialty === '__nueva__' && (
                      <input
                        className="task-input"
                        type="text"
                        placeholder="Escribir nueva sección"
                        onChange={(e) => setSpecialty(e.target.value)}
                        autoFocus
                        style={{ marginBottom: '8px' }}
                      />
                    )}

                    <input
                      className="date-input"
                      type="date"
                      value={dueDate}
                      onChange={(e) => setDueDate(e.target.value)}
                      required
                    />
                  </>
                )}
              </div>

            </div>

            <div style={S.footer}>
              <button type="button" style={S.cancelBtn} onClick={onCerrar}>Cancelar</button>
              <button type="submit" style={S.submitBtn}>Agregar Subcontrato</button>
            </div>
          </form>

        </div>
      </div>
    </>
  );
}

export default ModalAgregarSubcontrato;
